const stats = [
    { value: "400+", label: "Students" },
    { value: "95%", label: "Success Rate" },
    { value: "50+", label: "Batches Delivered" },
  ];
  
  export default function Stats() {
    return (
      <div className="w-full py-auto lg:py-0 lg:top-[600px] absolute px-[16px] lg:px-[158px] flex justify-center z-5">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-[24px] lg:gap-[32px]">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="flex items-center justify-center border border-primary rounded-[12px] py-[24px] lg:py-[30px] px-[40px] text-center gap-[16px] bg-white"
            >
              <p className="text-[48px] lg:text-[61px] font-[600] text-primary">{stat.value}</p>
              <p className="text-[#222222] font-[600]">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    );
  }
  